import { environment } from '../../../environments/environment';

/** API_URLS */
export const API_URLS = {

    CENTER_HUB: {
      FORM_GET : {
        url: environment.baseUrlDxlProd + '/public/v2/form',
        st: environment.baseUrlDxl + '/public/v2/form',
        preprod: environment.baseUrlDxlPreProdFullPath + '/public/v2/form',
        api_name: 'Form_Get',
    },
  },
  FORM_DETAILS: {
    FORM_DETAILS_GET: {
      url: environment.baseUrlDxlProd + '/public/v2/form/{id}',
      st: environment.baseUrlDxl + '/public/v2/form/{id}',
      preprod: environment.baseUrlDxlPreProdFullPath + '/public/v2/form/{id}',
      api_name: 'Form_Details_Get',
    },
    FORM_SUBMIT: {
      url: environment.baseUrlDxlProd + '/public/v2/form/{id}/submit',
      st: environment.baseUrlDxl + '/public-submit/v2/form/{id}/submit',
      preprod: environment.baseUrlDxlPreProdFullPath + '/public/v2/form/{id}/submit',
      api_name: 'Form_SUBMIT',
    },
  },

};
